var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ReturnBack"},[_c('div',{staticClass:"return",style:('background-color:'+ _vm.bcolor),on:{"click":_vm.returnBack}},[_c('van-icon',{attrs:{"color":_vm.rcolor,"size":"18px","name":"arrow-left"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }